/** Generated by @gh/common callable client codegen. Do not edit manually. */

import type { CallableApiConfig, RouteTypeMap } from "@gh/common/callable-client";
import type { CoordAdminCaptureCustomerConsentsRequest, CoordAttachBridgePolicyRequest, CoordAttachBridgePolicyResponse, CoordCancelClinicalConsultationRequest, CoordCancelClinicalConsultationResponse, CoordCaptureCustomerConsentsRequest, CoordCaptureCustomerConsentsResponse, CoordConfirmClinicalBookingRequest, CoordConfirmClinicalBookingResponse, CoordCreateClinicalConsultationRequest, CoordCreateClinicalConsultationResponse, CoordEnsureCustomerClinicalVendorsRequest, CoordEnsureCustomerClinicalVendorsResponse, CoordExplainCancelPendingRequest, CoordExplainCancelPendingResponse, CoordExtendClinicalHoldRequest, CoordExtendClinicalHoldResponse, CoordGenerateCarePlanForConsultationRequest, CoordGenerateCarePlanForConsultationResponse, CoordJoinClinicalConsultationZoomRequest, CoordJoinClinicalConsultationZoomResponse, CoordLinkStripeCustomerRequest, CoordLinkStripeCustomerResponse, CoordListCustomerConsultationDetailsRequest, CoordListCustomerConsultationDetailsResponse, CoordMintCarePlanAccessRequest, CoordMintCarePlanAccessResponse, CoordPrewarmConsultationStackRequest, CoordPrewarmConsultationStackResponse, CoordReserveClinicalSlotRequest, CoordReserveClinicalSlotResponse, CoordResolveResumableClinicalConsultationRequest, CoordResolveResumableClinicalConsultationResponse, CoordResumeBridgeSettlingRequest, CoordResumeBridgeSettlingResponse, CoordReturnClinicalConsultationToDraftRequest, CoordReturnClinicalConsultationToDraftResponse, CoordTriggerBridgePatientResolveRequest, CoordTriggerBridgePatientResolveResponse, CoordTriggerClinicalSelfPayCheckoutRequest, CoordTriggerClinicalSelfPayCheckoutResponse, CoordTriggerConsultantResolveRequest, CoordTriggerConsultantResolveResponse, CoordTriggerConsultationResolveRequest, CoordTriggerConsultationResolveResponse, CoordTriggerConsultationVendorResolveRequest, CoordTriggerConsultationVendorResolveResponse, CoordWaiveClinicalNoshowFeeRequest, CoordWaiveClinicalNoshowFeeResponse, CoordWaiveClinicalSettlementPaymentRequest, CoordWaiveClinicalSettlementPaymentResponse } from "../../src/types";



export interface PlatformCoordRouteTypeMap extends RouteTypeMap {
  adminCaptureCustomerConsents: {
    request: CoordAdminCaptureCustomerConsentsRequest;
    response: CoordCaptureCustomerConsentsResponse;
  };
  adminMintCarePlanAccess: {
    request: CoordMintCarePlanAccessRequest;
    response: CoordMintCarePlanAccessResponse;
  };
  attachBridgePolicy: {
    request: CoordAttachBridgePolicyRequest;
    response: CoordAttachBridgePolicyResponse;
  };
  cancelClinicalConsultation: {
    request: CoordCancelClinicalConsultationRequest;
    response: CoordCancelClinicalConsultationResponse;
  };
  captureCustomerConsents: {
    request: CoordCaptureCustomerConsentsRequest;
    response: CoordCaptureCustomerConsentsResponse;
  };
  confirmClinicalBooking: {
    request: CoordConfirmClinicalBookingRequest;
    response: CoordConfirmClinicalBookingResponse;
  };
  createClinicalConsultation: {
    request: CoordCreateClinicalConsultationRequest;
    response: CoordCreateClinicalConsultationResponse;
  };
  ensureCustomerClinicalVendors: {
    request: CoordEnsureCustomerClinicalVendorsRequest;
    response: CoordEnsureCustomerClinicalVendorsResponse;
  };
  explainCancelPending: {
    request: CoordExplainCancelPendingRequest;
    response: CoordExplainCancelPendingResponse;
  };
  extendClinicalHold: {
    request: CoordExtendClinicalHoldRequest;
    response: CoordExtendClinicalHoldResponse;
  };
  generateCarePlanForConsultation: {
    request: CoordGenerateCarePlanForConsultationRequest;
    response: CoordGenerateCarePlanForConsultationResponse;
  };
  joinClinicalConsultationZoom: {
    request: CoordJoinClinicalConsultationZoomRequest;
    response: CoordJoinClinicalConsultationZoomResponse;
  };
  linkStripeCustomer: {
    request: CoordLinkStripeCustomerRequest;
    response: CoordLinkStripeCustomerResponse;
  };
  listCustomerConsultationDetails: {
    request: CoordListCustomerConsultationDetailsRequest;
    response: CoordListCustomerConsultationDetailsResponse;
  };
  mintCarePlanAccess: {
    request: CoordMintCarePlanAccessRequest;
    response: CoordMintCarePlanAccessResponse;
  };
  prewarmConsultationStack: {
    request: CoordPrewarmConsultationStackRequest;
    response: CoordPrewarmConsultationStackResponse;
  };
  reserveClinicalSlot: {
    request: CoordReserveClinicalSlotRequest;
    response: CoordReserveClinicalSlotResponse;
  };
  resolveResumableClinicalConsultation: {
    request: CoordResolveResumableClinicalConsultationRequest;
    response: CoordResolveResumableClinicalConsultationResponse;
  };
  resumeBridgeSettling: {
    request: CoordResumeBridgeSettlingRequest;
    response: CoordResumeBridgeSettlingResponse;
  };
  returnClinicalConsultationToDraft: {
    request: CoordReturnClinicalConsultationToDraftRequest;
    response: CoordReturnClinicalConsultationToDraftResponse;
  };
  triggerBridgePatientResolve: {
    request: CoordTriggerBridgePatientResolveRequest;
    response: CoordTriggerBridgePatientResolveResponse;
  };
  triggerClinicalSelfPayCheckout: {
    request: CoordTriggerClinicalSelfPayCheckoutRequest;
    response: CoordTriggerClinicalSelfPayCheckoutResponse;
  };
  triggerConsultantResolve: {
    request: CoordTriggerConsultantResolveRequest;
    response: CoordTriggerConsultantResolveResponse;
  };
  triggerConsultationResolve: {
    request: CoordTriggerConsultationResolveRequest;
    response: CoordTriggerConsultationResolveResponse;
  };
  triggerConsultationVendorResolve: {
    request: CoordTriggerConsultationVendorResolveRequest;
    response: CoordTriggerConsultationVendorResolveResponse;
  };
  waiveClinicalNoshowFee: {
    request: CoordWaiveClinicalNoshowFeeRequest;
    response: CoordWaiveClinicalNoshowFeeResponse;
  };
  waiveClinicalSettlementPayment: {
    request: CoordWaiveClinicalSettlementPaymentRequest;
    response: CoordWaiveClinicalSettlementPaymentResponse;
  };
}

export const platformCoordApiConfig = {
  gatewayName: "platform_coord_default_gateway",
  routes: {
    adminCaptureCustomerConsents: {
      gateway: "platform_coord_default_gateway",
      action: "adminCaptureCustomerConsents",
    },
    adminMintCarePlanAccess: {
      gateway: "platform_coord_default_gateway",
      action: "adminMintCarePlanAccess",
    },
    attachBridgePolicy: {
      gateway: "platform_coord_default_gateway",
      action: "attachBridgePolicy",
    },
    cancelClinicalConsultation: {
      gateway: "platform_coord_default_gateway",
      action: "cancelClinicalConsultation",
    },
    captureCustomerConsents: {
      gateway: "platform_coord_default_gateway",
      action: "captureCustomerConsents",
    },
    confirmClinicalBooking: {
      gateway: "platform_coord_default_gateway",
      action: "confirmClinicalBooking",
    },
    createClinicalConsultation: {
      gateway: "platform_coord_default_gateway",
      action: "createClinicalConsultation",
    },
    ensureCustomerClinicalVendors: {
      gateway: "platform_coord_default_gateway",
      action: "ensureCustomerClinicalVendors",
    },
    explainCancelPending: {
      gateway: "platform_coord_default_gateway",
      action: "explainCancelPending",
    },
    extendClinicalHold: {
      gateway: "platform_coord_default_gateway",
      action: "extendClinicalHold",
    },
    generateCarePlanForConsultation: {
      gateway: "platform_coord_default_gateway",
      action: "generateCarePlanForConsultation",
    },
    joinClinicalConsultationZoom: {
      gateway: "platform_coord_default_gateway",
      action: "joinClinicalConsultationZoom",
    },
    linkStripeCustomer: {
      gateway: "platform_coord_default_gateway",
      action: "linkStripeCustomer",
    },
    listCustomerConsultationDetails: {
      gateway: "platform_coord_default_gateway",
      action: "listCustomerConsultationDetails",
    },
    mintCarePlanAccess: {
      gateway: "platform_coord_default_gateway",
      action: "mintCarePlanAccess",
    },
    prewarmConsultationStack: {
      gateway: "platform_coord_default_gateway",
      action: "prewarmConsultationStack",
    },
    reserveClinicalSlot: {
      gateway: "platform_coord_default_gateway",
      action: "reserveClinicalSlot",
    },
    resolveResumableClinicalConsultation: {
      gateway: "platform_coord_default_gateway",
      action: "resolveResumableClinicalConsultation",
    },
    resumeBridgeSettling: {
      gateway: "platform_coord_default_gateway",
      action: "resumeBridgeSettling",
    },
    returnClinicalConsultationToDraft: {
      gateway: "platform_coord_default_gateway",
      action: "returnClinicalConsultationToDraft",
    },
    triggerBridgePatientResolve: {
      gateway: "platform_coord_default_gateway",
      action: "triggerBridgePatientResolve",
    },
    triggerClinicalSelfPayCheckout: {
      gateway: "platform_coord_default_gateway",
      action: "triggerClinicalSelfPayCheckout",
    },
    triggerConsultantResolve: {
      gateway: "platform_coord_default_gateway",
      action: "triggerConsultantResolve",
    },
    triggerConsultationResolve: {
      gateway: "platform_coord_default_gateway",
      action: "triggerConsultationResolve",
    },
    triggerConsultationVendorResolve: {
      gateway: "platform_coord_default_gateway",
      action: "triggerConsultationVendorResolve",
    },
    waiveClinicalNoshowFee: {
      gateway: "platform_coord_default_gateway",
      action: "waiveClinicalNoshowFee",
    },
    waiveClinicalSettlementPayment: {
      gateway: "platform_coord_default_gateway",
      action: "waiveClinicalSettlementPayment",
    },
  },
} as const satisfies CallableApiConfig<PlatformCoordRouteTypeMap>;
